"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Empty = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _Empty = require("./Empty.styles");

var _Button = require("../../atoms/button/Button");

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Empty = ({
  className,
  primaryText,
  secondaryText,
  buttonProps,
  children,
  footerContent,
  markdown
}) => {
  return /*#__PURE__*/_react.default.createElement(_Empty.StyledEmptyWrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "empty-inner"
  }, primaryText && /*#__PURE__*/_react.default.createElement("div", {
    className: "primary-text"
  }, (0, _utils.lineBreak)(primaryText)), secondaryText && /*#__PURE__*/_react.default.createElement("div", {
    className: "secondary-text"
  }, markdown ? /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, null, secondaryText) : (0, _utils.lineBreak)(secondaryText)), buttonProps && /*#__PURE__*/_react.default.createElement("div", {
    className: "button-block"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, buttonProps)), footerContent && /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-content"
  }, /*#__PURE__*/_react.default.isValidElement(footerContent) ? footerContent : /*#__PURE__*/_react.default.createElement(_reactMarkdown.default, null, footerContent)), children && children));
};

exports.Empty = Empty;
Empty.defaultProps = {
  footerContent: '',
  markdown: true
};
Empty.propTypes = {
  /** Primary Text for Empty Component*/
  primaryText: _propTypes.default.string,

  /** Secondary Text for Empty Component, by default markdown is enabled for string*/
  secondaryText: _propTypes.default.string,

  /** custom class can be passed here for Empty container */
  className: _propTypes.default.string,

  /** All Button props can be passed here, for more info refer atoms/buttons*/
  buttonProps: _propTypes.default.object,

  /** The Children should be a React element*/
  children: _propTypes.default.element,

  /** The footerContent should be anything that can be rendered by React — a number, string, element, or array (or fragment) containing these types, by default markdown is enabled for string*/
  footerContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.node]),

  /** markdown for both secondaryText and footerContent(only for string type)*/
  markdown: _propTypes.default.bool
};